module.exports = __webpack_public_path__ + "img/mile6.c2bba661.webp";